import KformComponent from '~/components/kform/components/kform-component';

export default class FormComponent extends KformComponent {
	/**
	 * @param {import('@knitiv/api-client-javascript').ComponentForm | undefined} settings
	 */
	constructor(settings = undefined) {
		super(settings);
		this.input = true;
		this.kdata = {
			...settings?.kdata,
		};
	}
}
